import { erpAxios } from '..';

const getCRKDocuments = async (jmbg, tipIzvjestaja) => {
  const { data } = await erpAxios.get(`/crkKrediti/${jmbg}/${tipIzvjestaja}`);
  return data;
};

export default getCRKDocuments;
